import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChatsDashboardStore } from '@principle-theorem/ng-chats';
import { ManagementToolSidebarService } from '@principle-theorem/ng-management-tools';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';
import { SidebarManagerService } from '@principle-theorem/ng-shared';
import { type INotification } from '@principle-theorem/notifications';
import { Staffer } from '@principle-theorem/principle-core';
import {
  count,
  filterUndefined,
  isPathChanged$,
  limit,
  orderBy,
  query$,
  where,
  type WithRef,
} from '@principle-theorem/shared';
import { type Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'pr-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SettingsComponent {
  chatCount$: Observable<number>;
  notifications$: Observable<WithRef<INotification>[]>;
  notificationsOpen = false;

  constructor(
    public sidebar: SidebarManagerService,
    public managementSidebar: ManagementToolSidebarService,
    private _organisation: OrganisationService,
    chats: ChatsDashboardStore
  ) {
    this.notifications$ = this._organisation.staffer$.pipe(
      isPathChanged$('ref.path'),
      filterUndefined(),
      switchMap((staffer) =>
        query$(
          Staffer.notificationCol(staffer),
          where('viewed', '==', false),
          orderBy('createdAt', 'desc'),
          limit(30)
        )
      )
    );
    this.chatCount$ = chats.unreadChats$.pipe(count());
  }
}
